export const GET_PACKAGE_LIST = 'GET_PACKAGE_LIST';
export const GET_NEXT_PAGE_PACKAGE_LIST = 'GET_NEXT_PAGE_PACKAGE_LIST';
export const SET_PACKAGE_LIST = 'SET_PACKAGE_LIST';
export const GET_PACKAGE_DETAILS = 'GET_PACKAGE_DETAILS';
export const SET_PACKAGE_DETAILS = 'SET_PACKAGE_DETAILS';
export const CLEAR_PACKAGE_VIEW = 'CLEAR_PACKAGE_VIEW';
export const UPDATE_PACKAGE = 'UPDATE_PACKAGE';
export const UPDATE_PACKAGE_SUCCESS = 'UPDATE_PACKAGE_SUCCESS';
export const CREATE_PACKAGE = 'CREATE_PACKAGE';
export const CREATE_PACKAGE_SUCCESS = 'CREATE_PACKAGE_SUCCESS';
export const CREATE_PACKAGE_FAILURE = 'CREATE_PACKAGE_FAILURE';
export const UPDATE_PACKAGE_STATUS = 'UPDATE_PACKAGE_STATUS';
export const UPDATE_PACKAGE_STATUS_SUCCESS = 'UPDATE_PACKAGE_STATUS_SUCCESS';
export const UPDATE_PACKAGE_STATUS_FAILURE = 'UPDATE_PACKAGE_STATUS_FAILURE';
export const SET_STATUS_UPDATE_SUCCESS = 'SET_STATUS_UPDATE_SUCCESS';
